import { FullNameType } from '../types';
import { formatName } from './format-name';

/**
 * Returns full name based on input object.
 */
export const genericFormatName = (data?: FullNameType, fallback = '-'): string => {
  if (!data) return fallback;
  return formatName(data.firstName ?? data.name, data.lastName ?? data.surname, fallback);
};
